import styles from "./CartModal.module.css";
import React, { useEffect, useState } from "react";
import { FaMinus, FaPlus, FaTrashCan } from "react-icons/fa6";
import Booster from "../../Boosters/Booster";
import { useCartContext } from "../../../context/CartProvider";
import globalStyles from "../../../styles/globalStyles.module.css";
import { boosterQuantity } from "../../../context/CartProvider";
import quantityButtonsStyles from "../../Buttons/AddToCartButton/AddToCartButton.module.css";
import { Link } from "react-router-dom";
import { createStripeSession } from "../../../services/StripeServices";
import { requestBoosterQuantity } from "../../../services/StripeServices";
import { useTranslation } from "react-i18next";
import { useAlert } from "../../../context/AlertProvider";

export const CartModal: React.FC<{
  isOpen: boolean;
  handleClose: () => void;
}> = ({ isOpen, handleClose }) => {
  // const [isOpen, setIsOpen] = useState(false);
  const { items, removeFromCart, increaseItemQuantity, decreaseItemQuantity } =
    useCartContext();
  const [totalPrice, setTotalPrice] = useState<number>(0);
  const { t } = useTranslation();
  const { showAlert } = useAlert();

  useEffect(() => {
    let totalPriceValue = 0;
    items.forEach((item: boosterQuantity) => {
      totalPriceValue += item.quantity * item.booster.price;
    });

    setTotalPrice(totalPriceValue);
  }, [items]);

  const handleCheckout = async () => {
    try {
      const requestItems: requestBoosterQuantity[] = [];

      items.forEach((item: boosterQuantity) => {
        requestItems.push({
          boosterId: item.booster.id,
          quantity: item.quantity,
        });
      });

      const json = await createStripeSession(requestItems);

      const { url } = json;
      if (url) {
        window.location.href = url;
      }
    } catch (error) {
      console.error("Error during checkout:", error);
      if (error instanceof Error) {
        showAlert(error.message);
      } else showAlert("An unexpected error occurred during checkout.");
    }
  };

  return (
    <>
      {isOpen && (
        <div className={styles.modalOverlay} onClick={handleClose}>
          <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
            <h2>{t("cart.modal.title")}</h2>
            <div>{t("cart.modal.description")}</div>
            <div className={styles.itemContainer}>
              {items.map((item: boosterQuantity, index) => (
                <div key={index} className={styles.item}>
                  <div className={styles.boosterImage}>
                    <Link
                      to={`/boosters/${item.booster.id}`}
                      className={styles.link}
                      onClick={handleClose}
                    >
                      <Booster
                        booster={item.booster}
                        isInStore={true}
                        disableHover={true}
                      />
                    </Link>
                  </div>
                  <div className={styles.priceContainer}>
                    <div className={styles.resumeContainer}>
                      <Link
                        to={`/boosters/${item.booster.id}`}
                        className={styles.link}
                        onClick={handleClose}
                      >
                        <strong>
                          {t("cart.modal.item.title")} - {item.booster.name}
                        </strong>
                      </Link>
                      <p>{item.booster.price}€</p>

                      <div
                        className={
                          quantityButtonsStyles.quantityButtonsContainer
                        }
                      >
                        <button
                          className={`${globalStyles.button} ${quantityButtonsStyles.minus}`}
                          onClick={() => decreaseItemQuantity(item)}
                        >
                          <FaMinus />
                        </button>
                        <div className={quantityButtonsStyles.quantityInput}>
                          {item.quantity}
                        </div>
                        <button
                          className={`${globalStyles.button} ${quantityButtonsStyles.plus}`}
                          onClick={() => increaseItemQuantity(item)}
                        >
                          <FaPlus />
                        </button>
                        <button
                          className={`${globalStyles.button} ${styles.trashButton}`}
                          onClick={() => removeFromCart(item.booster)}
                        >
                          <FaTrashCan />
                        </button>
                      </div>
                    </div>
                    <strong>{item.booster.price * item.quantity}€</strong>
                  </div>
                </div>
              ))}
            </div>
            <div className={styles.totalContainer}>
              <div className={styles.priceContainer}>
                <h4>{t("total")}</h4>
                <h2>{totalPrice}€</h2>
              </div>
              <button
                className={`${globalStyles.button} ${styles.checkoutButton}`}
                onClick={handleCheckout}
              >
                <strong>{t("checkout")}</strong>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
